/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_soldil_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Need 250 mL of 2 mM from a 50 mM stock: V1 = (2 mM × 250 mL) / 50 mM = 10 mL.`)
};

const es_soldil_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Necesitas 250 mL de 2 mM a partir de un stock de 50 mM: V1 = (2 mM × 250 mL) / 50 mM = 10 mL.`)
};

const de_soldil_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Benötigt werden 250 mL von 2 mM aus einer 50 mM Stammlösung: V1 = (2 mM × 250 mL) / 50 mM = 10 mL.`)
};

const nl_soldil_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nodig: 250 mL van 2 mM uit een 50 mM stock: V1 = (2 mM × 250 mL) / 50 mM = 10 mL.`)
};

const fr_soldil_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Besoin de 250 mL à 2 mM à partir d'une solution mère à 50 mM : V1 = (2 mM × 250 mL) / 50 mM = 10 mL.`)
};

const it_soldil_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Servono 250 mL di 2 mM da una soluzione madre 50 mM: V1 = (2 mM × 250 mL) / 50 mM = 10 mL.`)
};

const pt_br2_soldil_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Necessário 250 mL de 2 mM a partir de um estoque 50 mM: V1 = (2 mM × 250 mL) / 50 mM = 10 mL.`)
};

const pt_soldil_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Precisa de 250 mL de 2 mM a partir de uma solução-mãe de 50 mM: V1 = (2 mM × 250 mL) / 50 mM = 10 mL.`)
};

const ja_soldil_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`50 mM ストックから2 mMを250 mL必要: V1 = (2 mM × 250 mL) / 50 mM = 10 mL。`)
};

const zh_soldil_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`需要用 50 mM 母液配制 250 mL 的 2 mM 溶液：V1 = (2 mM × 250 mL) / 50 mM = 10 mL。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const soldil_ex3 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.soldil_ex3(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("soldil_ex3", locale)
	if (locale === "en") return en_soldil_ex3(inputs)
	if (locale === "es") return es_soldil_ex3(inputs)
	if (locale === "de") return de_soldil_ex3(inputs)
	if (locale === "nl") return nl_soldil_ex3(inputs)
	if (locale === "fr") return fr_soldil_ex3(inputs)
	if (locale === "it") return it_soldil_ex3(inputs)
	if (locale === "pt-BR") return pt_br2_soldil_ex3(inputs)
	if (locale === "pt") return pt_soldil_ex3(inputs)
	if (locale === "ja") return ja_soldil_ex3(inputs)
	return zh_soldil_ex3(inputs)
};